// extracted by mini-css-extract-plugin
export default {"pageShell":"GCoY0Fi","pageHeader":"uRNvCPv","pageCard":"N9KdJbr","formShell":"AFPbNnW","formDropdowns":"TyJS1tI","formColumn":"cnVH45l","note":"W4Q58QI","submitButton":"g34uJ8M"};